import {
  QueryKey,
  useMutation,
  useQuery,
  UseQueryOptions
} from "@tanstack/react-query";

import { SchoolEntityI } from "@seneca/schools-service-types";

import {
  fetchTeacherClasses,
  fetchTeacherSchools,
  inviteAllSchoolParents
} from "../client";
import { schoolClassesKey, schoolsKey } from "../consts";

const DAY_IN_MILLISECONDS = 60 * 60 * 24 * 1000;

export function useFetchTeacherSchools(
  opts: UseQueryOptions<SchoolEntityI[]> = {}
) {
  const defaultOptions: UseQueryOptions<SchoolEntityI[]> = {
    staleTime: DAY_IN_MILLISECONDS / 2
  };

  return useQuery<SchoolEntityI[]>(
    [schoolsKey] as QueryKey,
    fetchTeacherSchools,
    {
      ...defaultOptions,
      ...opts
    }
  );
}

export function useFetchTeacherClasses(
  schoolId: string,
  opts?: UseQueryOptions
) {
  return useQuery(
    [schoolClassesKey, schoolId] as QueryKey,
    () => fetchTeacherClasses(schoolId),
    opts
  );
}

export function useInviteAllSchoolParents({
  schoolId,
  onSuccess
}: {
  schoolId: string;
  onSuccess: () => void;
}) {
  return useMutation(
    [schoolClassesKey, schoolId],
    () => inviteAllSchoolParents(schoolId),
    { onSuccess }
  );
}
